import { ERROR_PAGES } from "../../constants/actionTypes";

const initialUserState = {
  errorType: "",
  redirectUrl:""
};

export const errorReducer = (state = initialUserState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case ERROR_PAGES.SET_ERROR:
      newState.errorType = action.payload;
      return newState;
    case ERROR_PAGES.SET_REDIRECT_URL:
      newState.redirectUrl = newState.redirectUrl === "" ? action.payload: newState.redirectUrl
      return newState
    case ERROR_PAGES.CLEAR_ERROR:
      newState.errorType = "";
      newState.redirectUrl = ""
      return newState
    default:
      return newState;
  }
};